import { Component, OnInit } from '@angular/core';
import { TaskResponse, UserResponse } from '@core/generated/openapi';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TaskService } from '@services/tasks/task.service';
import { AuthService } from '@services/auth/auth.service';
import { NotificationServiceUP } from '@services/notifications/notification-service-u-p.service';
import { WorklistUserNotificationService } from '@services/user-notifications/worklist-user-notification.service';
import { ButtonStyle } from 'rcp-common-lib';

@UntilDestroy()
@Component({
    selector: 'rcp-oup-worklist-summary-home',
    templateUrl: './worklist-summary-home.component.html',
    styleUrls: ['./worklist-summary-home.component.scss'],
    standalone: false,
})
export class WorklistSummaryHomeComponent implements OnInit {
    isNotificationsHovered: boolean = false;
    isToDoHovered: boolean = false;
    isIssuesHovered: boolean = false;
    currentUser: UserResponse;
    currentUserId: number;
    isLoading: boolean = false;

    toDos: TaskResponse[];

    get allOpenNotifications() {
        return this.notificationService.ALL_OPEN_NOTIFICATIONS;
    }

    constructor(
        private taskService: TaskService,
        private authService: AuthService,
        private alertsService: NotificationServiceUP,
        private notificationService: WorklistUserNotificationService,
    ) {
        this.authService
            .getCurrentUser()
            .pipe(untilDestroyed(this))
            .subscribe((user) => {
                this.currentUser = user;
            });
    }

    ngOnInit(): void {
        setTimeout(() => {
            this.lookup();
        }, 400);
    }

    lookup() {
        this.isLoading = true;
        let search = {
            ownerId: this.currentUser.id,
        };
        this.taskService
            .findMyTasks(search)
            .pipe(untilDestroyed(this))
            .subscribe({
                next: (response) => {
                    this.toDos = response.filter(
                        (toDo) => toDo.status == 'ACTIVE',
                    );
                    this.taskService.setToDos(this.toDos);
                },
                error: (error) => {
                    this.isLoading = false;
                    this.alertsService.showError(
                        'Error looking up My Tasks.',
                        error.error,
                    );
                    console.error(error);
                },
                complete: () => {
                    this.isLoading = false;
                },
            });

        this.notificationService.findAllOpenNotifications();
    }

    protected readonly ButtonStyle = ButtonStyle;
}
